module.exports = __webpack_public_path__ + "static/media/win.badb26b6.png";